<script>
import moment, { duration } from 'moment'

export default {
    components: {},
    props: {
        value: {
            required: false,
            type: Array
        },
        event: String,
        practice: Boolean,
        qualifying: Boolean,
        race: Boolean
    },
    watch: {
        value() {
            this.onUpdateValue()
        },
        sessionPractice() {
            this.onUpdate()
        },
        sessionPracticeDuration() {
            this.onUpdate()
        },
        sessionQualifying() {
            this.onUpdate()
        },
        sessionQualifyingDuration() {
            this.onUpdate()
        },
        sessionRace() {
            this.onUpdate()
        },
        sessionRaceDuration() {
            this.onUpdate()
        },
        sessionRaceLaps() {
            this.onUpdate()
        },
        durations() {
            this.$emit('durations', this.durations)
        }
    },
    computed: {
        sessions() {
            const sessions = []

            if (this.sessionPractice) {
                sessions.push({
                    name: 'Practice',
                    type: 'PRACTICE',
                    spawn: 'PIT',
                    ordering: sessions.length,
                    duration: this.sessionPracticeDuration
                })
            }

            if (this.sessionQualifying) {
                sessions.push({
                    name: 'Qualifying',
                    type: 'QUALIFYING',
                    spawn: 'PIT',
                    ordering: sessions.length,
                    duration: this.sessionQualifyingDuration
                })
            }

            if (this.sessionRace) {
                sessions.push({
                    name: 'Race',
                    type: 'RACE',
                    spawn: 'START',
                    ordering: sessions.length,
                    duration: this.sessionRaceDuration,
                    duration_is_laps: this.sessionRaceLaps
                })
            }

            if (this.event) {
                for (let session of sessions) {
                    session.event = this.event
                }
            }

            return sessions
        },
        durations() {
            let minutes = 0
            let laps = 0

            for (let session of this.sessions) {
                if (session.duration_is_laps) {
                    laps += session.duration
                } else {
                    minutes += Math.round(session.duration + 1.2)
                }
            }

            const end = moment().add(minutes, 'minutes').format('h:mma')

            return { minutes, laps, end }
        }
    },
    data() {
        return {
            sessionPractice: false,
            sessionPracticeDuration: 25,
            sessionQualifying: false,
            sessionQualifyingDuration: 15,
            sessionRace: false,
            sessionRaceDuration: 10,
            sessionRaceLaps: false,
        }
    },
    methods: {
        initialize() {
            this.sessionPractice = this.practice
            this.sessionQualifying = this.qualifying
            this.sessionRace = this.race
            this.onUpdateValue()
        },
        onUpdate() {
            this.$emit('input', this.sessions)
        },
        onUpdateValue() {
            for (let session of this.value) {
                if (session.type == 'PRACTICE') {
                    this.sessionPractice = true
                    this.sessionPracticeDuration = session.duration
                } else if (session.type == 'QUALIFYING') {
                    this.sessionQualifying = true
                    this.sessionQualifyingDuration = session.duration
                } else if (session.type == 'RACE') {
                    this.sessionRace = true
                    this.sessionRaceDuration = session.duration
                    this.sessionRaceLaps = session.duration_is_laps
                }
            }
        },
        updateDurations() {
            this.sessionPractice += 1
            this.$nextTick(() => this.sessionPractice -= 1)
        }
    },
    mounted() {
        this.initialize()
    },
}
</script>

<template>
    <div>
        <b-table-simple class="mb-0" borderless>
            <b-tbody>
                <b-tr :class="{ 'text-muted': !sessionPractice }">
                    <b-td :class="{ 'font-weight-bold': sessionPractice }">Practice</b-td>
                    <b-td><b-form-checkbox switch v-model="sessionPractice" size="sm" /></b-td>
                    <b-td><b-form-spinbutton :disabled="!sessionPractice" v-model="sessionPracticeDuration" size="sm" :formatter-fn="value => `${value} Mins`" /></b-td>
                </b-tr>

                <b-tr :class="{ 'text-muted': !sessionQualifying }">
                    <b-td :class="{ 'font-weight-bold': sessionQualifying }">Qualifying</b-td>
                    <b-td><b-form-checkbox switch v-model="sessionQualifying" size="sm" /></b-td>
                    <b-td><b-form-spinbutton :disabled="!sessionQualifying" v-model="sessionQualifyingDuration" size="sm" :formatter-fn="value => `${value} Mins`" /></b-td>
                </b-tr>

                <b-tr :class="{ 'text-muted': !sessionRace }">
                    <b-td :class="{ 'font-weight-bold': sessionRace }">Race</b-td>
                    <b-td><b-form-checkbox switch v-model="sessionRace" size="sm" /></b-td>
                    <b-td>
                        <b-form-spinbutton
                            :disabled="!sessionRace"
                            v-model="sessionRaceDuration"
                            size="sm"
                            :formatter-fn="value => `${value} ${sessionRaceLaps ? 'Laps' : 'Mins'}`"
                        />
                    </b-td>
                </b-tr>

                <b-tr v-if="sessionRace">
                    <b-td />
                    <b-td><b-form-checkbox switch v-model="sessionRaceLaps" size="sm" /></b-td>
                    <b-td><small>Race Duration is Laps</small></b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<style lang="scss" scoped>
</style>
